import * as THREE from "three";
import Experience from "./Experience.js";
import $ from "jquery";

export default class EventManager {
  constructor(_canvas) {
    this.experience = new Experience();
    this.room = this.experience.room;
    this.walls = this.room.walls;
    this.renderer = this.experience.renderer;
    this.camera = this.experience.camera;
    this.scene = this.experience.scene;
    this.objectManager = this.experience.objectManager;
    this.objectsControl = this.room.objectsControl;
    this.measures = this.experience.measures;
    this.saveRoom = this.room.saveRoom;

    window.addEventListener(
      "pointerdown",
      () => {
        this.room.onPointerDown(event);
      },
      false
    );

    window.addEventListener(
      "pointerup",
      () => {
        this.room.onPointerUp(event);
      },
      false
    );

    /**
     * Event button 2D
     */
    document.getElementById("button2d").addEventListener(
      "pointerdown",
      (e) => {
        e.preventDefault();
        this.camera.toggleViews();
        this.room.detachSelectedObject();
        this.measures.removeMeasuresOfObject();
        this.measures.removeMeasuresWalls();
        if (
          !document
            .getElementById("buttonsActionConfigurator")
            .classList.contains("d-none")
        ) {
          document
            .getElementById("buttonsActionConfigurator")
            .classList.add("d-none");
        }

        if (this.camera.is2DView) {
          e.target.querySelector("img").src = "./images/icons/icon_3d.png";
          this.measures.createMeasuresWalls(this.room.shape,this.room.getWallSegments());
          this.measures.toggleVisibility(true);
        } else {
          e.target.querySelector("img").src =
            "./images/icons/icon_measures.png";
        }
        this.experience.menuManager.openContainerHideMeasures2dPlan();
      },
      false
    );

    /**
     * Screen of canvas
     */
    document.getElementById("screen").addEventListener("pointerdown", (e) => {
      e.preventDefault();
      const canvas = document.getElementById("webgl");
      if (this.camera.is2DView) {
        this.renderer.instance.render(this.scene, this.camera.orthographic);
      } else {
        this.renderer.instance.render(this.scene, this.camera.instance);
      }
      // Screen image
      const imageURL = canvas.toDataURL("image/png");

      // Save image in sessionStorage
      this.saveRoom.saveScreenInTab(imageURL);

      showNotification(
        "<p style='color:#0c4555;'>La capture de cette vue est enregistrée.</p><img src='./images/icons/screenshot.png' width='100' />"
      );
    });

    /**
     * Exit page
     */
    document.getElementById("exit").addEventListener("pointerdown", (e) => {
      e.preventDefault();
      // Affiche une fenêtre de confirmation
      if (
        confirm(
          "En quittant, vous perdrez toutes vos modifications.\n\nÊtes-vous certain(e) de vouloir partir ?"
        )
      ) {
        window.location.reload(); // Recharge la page si l'utilisateur confirme
      }
    });

    /**
     * Show notification
     * @param {*} text text of notification
     * @param {*} type default or danger
     */
    function showNotification(text, type = "default") {
      const containerNotification = document.getElementById("notification");

      containerNotification.classList.remove("danger", "default", "d-none");

      containerNotification.classList.add(type);
      containerNotification.innerHTML = text;

      setTimeout(() => {
        containerNotification.classList.add("d-none");
      }, 1500);
    }

    /**
     * Create ZIP
     */
    /* document.getElementById("zip").addEventListener("click", () => {
      
      this.saveRoom.createZipWithScreenshots();
    }); */

    /**
     * Open modal Save project
     */
    const modal = document.getElementById("modalSaveProject");

    // Lors de l'ouverture de la modal
    /*  modal.addEventListener("show.bs.modal", () => {
      document.body.classList.add("disable-pointer-events");
    }); */
    const modalBody = document.getElementById("modalSaveProjectBody");
    const originalModalContent = modalBody.innerHTML;
    // Lors de la fermeture de la modal
    modal.addEventListener("hidden.bs.modal", () => {
      // Restaurer le contenu original
      modalBody.innerHTML = originalModalContent;

      // Supprimer des classes ou effectuer d'autres nettoyages si nécessaire
      document.body.classList.remove("disable-pointer-events");
    });

    /**
     * Save project
     */
    document.getElementById("modalSaveProject").addEventListener("submit", (e) => {
      if (e.target && e.target.id === "saveProjectForm") {
        e.preventDefault();
        this.saveRoom.handleProjectSave(e);
      }
    });

    /**
     * Button back (click on wall, partition, etc.)
     */
    if (document.getElementById("buttonBackMenuTextures")) {
      document
        .getElementById("buttonBackMenuTextures")
        .addEventListener("click", (e) => {
          console.log("back");
        });
    }

    /**
     * Button remove an object in scene
     */
    document
      .getElementById("deleteObjectSelect")
      .addEventListener("click", (e) => {
        this.room.removeObject();
        document
          .getElementById("buttonsActionConfigurator")
          .classList.add("d-none");
        showNotification("Produit supprimé", "danger");
      });

    /**
     * Button duplicate an object in scene
     */
    document
      .getElementById("duplicateObjectSelect")
      .addEventListener("click", (e) => {
        this.room.duplicateObject();
        document
          .getElementById("buttonsActionConfigurator")
          .classList.add("d-none");
        showNotification("Produit dupliqué");
      });

    const productContainer = document.getElementById("productContainer");

    productContainer.addEventListener("click", (e) => {
      const target = e.target.closest(".card-body, .replaceObject, .addObject");

      // Vérifie si un élément cliquable a été trouvé
      if (!target) return;

      // Gestion des clics sur les textures de sol et de mur
      const type = target.dataset.type;
      const id = target.dataset.id || null;
      const subType = target.dataset.subtype || null;
      const src = target.dataset.src;

      if (type === "floor" && target.classList.contains("card-body")) {
        this.room.floor.setTexture(src);
      } else if (
        type === "wall" &&
        target.classList.contains("card-body") &&
        !this.room.getIsSelectedWall()
      ) {
        this.room.walls.changeAllWallTextures(src);
      } else if (type === "wall" && e.target.dataset.type === "wall") {
        // Si un élément de texture de mur est cliqué
        this.room.walls.changeWallTexture(
          src,
          this.room.walls.currentClickedObject
        );
      } else if (target.classList.contains("replaceObject")) {
        // Si le bouton "replaceObject" est cliqué
        this.objectManager.replaceObject(type, { modelPath: src, id: id });
      } else if (target.classList.contains("addObject")) {
        // Si le bouton "addObject" est cliqué
        const objectData = {modelPath: src};
        if (subType !== null) {
          objectData.subType = subType;
        }

        if (id !== null) {
          objectData.id = id;
        }
        
        
        this.objectManager.createObject(type, objectData);
        console.log("Objet ajouté !");
      } else {
        // Gestion de la texture de l'objet sélectionné
        const selectedObject = this.room.getSelectedObject();
        if (selectedObject) {
          const selectedMesh = this.room.getSelectedObject();
          if (selectedMesh) {
            const selectedInstance = selectedMesh.userData.instance;
            if (
              selectedInstance &&
              typeof selectedInstance.setTexture === "function"
            ) {
              selectedInstance.setTexture(src);
            } else {
              console.warn(
                "L'objet sélectionné ne peut pas changer de texture :",
                selectedMesh
              );
            }
          }
        }
      }
    });

    /**
     * Button add object (Tooltip)
     */
    document.addEventListener("submit", (event) => {
      if (event.target.closest(".formMeasures")) {
        event.preventDefault(); // Empêche le comportement par défaut du formulaire (rechargement de page)
        
        // Récupère le formulaire
        const form = event.target.closest(".formMeasures");
        if (!form) return;

        const buttonSubmit = form.querySelector('.submitFormMeasures');
        

        // Get value input
        const length =
          parseFloat(form.elements["lengthObject"]?.value) / 1000 || 1; // / 1000 : mm to m
        const height =
          parseFloat(form.elements["heightObject"]?.value) / 1000 || 1; // / 1000 : mm to m
        const width =
          parseFloat(form.elements["widthObject"]?.value) / 1000 || 1; // / 1000 : mm to m
        const pn = form.elements["pnObject"]?.value || null;

        const aimantee = form.elements["aimanteeObject"]?.value || null;

        const rideauLeste = form.elements["rideauLesteObject"]?.value || null;       
        

        const subType = form.elements["subType"]?.value || null;

        const scale = new THREE.Vector3(length, height, width);

        const objectData = { scale };
        

        if (buttonSubmit.dataset.src !== undefined) {
          objectData.modelPath = buttonSubmit.dataset.src;
        }

        if (subType !== null) {
          objectData.subType = subType;
        }

        if (pn !== null) {
          objectData.pn = pn;
        }

        if (aimantee !== null) {
          objectData.aimantee = aimantee;
        }

        if (rideauLeste !== null) {
          objectData.rideauLeste = rideauLeste;
        }

        // Create object
        this.objectManager.createObject(
          buttonSubmit.dataset.type,
          objectData
        );



        // Reinit form
        form.reset();
      }
    });

    /**
     * Button hide measures - Plan 2d
     */

    /* document.getElementById("hideMeasures").addEventListener("click", (e) => {
      // hide measures
      this.measures.toggleVisibility();

      e.target.textContent = this.measures.visible
        ? "Cacher les mesures"
        : "Afficher les mesures";
    }); */

    /**
     * Button turn object
     */
    document.getElementById("turnObject").addEventListener("click", (event) => {
      event.stopPropagation();
      
      if (
        this.room.getSelectedObject() &&
        this.room.getSelectedObject().name === "showerGrabBar"
      ) {
        this.room.getSelectedObject().rotation.z += Math.PI / 6;
      } else if (
        this.room.getSelectedObject() &&
        this.room.getSelectedObject().name === "showerWall" &&
        this.room.getSelectedObject().userData.subType === "rabat"
      ) {
        this.room.getSelectedObject().rotation.y += Math.PI / 4;
      } else if (this.room.getSelectedObject()) {
        this.room.getSelectedObject().rotation.y += Math.PI / 2;
      }
    });
  }

  onMouseDown(event) {
    event.preventDefault();
    this.room.onMouseDown(event);
  }

  onMouseUp(event) {
    event.preventDefault();
    this.room.onMouseUp(event);
  }

  onMouseMove(event) {
    event.preventDefault();
    this.room.onMouseMove(event);
  }

  onPointerDown(event) {
    event.preventDefault();

    //this.room.onPointerDown(event);
  }
}
